<template>
    <rkm-modal
        title="Configuração de fichas da atenção básica"
        ref="RkmModal"
    >
        <rkm-form>
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :options="data.form.atencaoBasicaFuncionalidades"
                        class="mb-0"
                        name="Fichas"
                        stacked
                        text-field="nome"
                        v-model="model.atencaoBasicaFuncionalidades"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    data: () => ({
        item: null,
        model: {
            atencaoBasicaFuncionalidades: null,
        },
    }),
    methods: {
        open(item) {
            this.resetForm()

            this.item = item

            this.model.atencaoBasicaFuncionalidades = this.clone(item.atencaoBasicaFuncionalidades)

            this.$refs.RkmModal.show()
        },
        save() {
            this.item.atencaoBasicaFuncionalidades = this.model.atencaoBasicaFuncionalidades

            this.$refs.RkmModal.hide()
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.model.atencaoBasicaFuncionalidades = []
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>